
import React from 'react';
import { TableHead } from '@/components/ui/table';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { SortField, SortOrder } from '@/hooks/useStudentList';

interface SortableColumnProps {
  field: SortField;
  label: string;
  currentSortField: SortField;
  sortOrder: SortOrder;
  onSort: (field: SortField) => void;
}

export const SortableColumn: React.FC<SortableColumnProps> = ({ 
  field, 
  label, 
  currentSortField, 
  sortOrder,
  onSort 
}) => {
  const isSorted = currentSortField === field;
  
  return (
    <TableHead 
      className="cursor-pointer hover:bg-gray-100 transition-colors"
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        {isSorted && (
          sortOrder === 'asc' ? 
            <ArrowUp className="h-4 w-4" /> : 
            <ArrowDown className="h-4 w-4" />
        )}
      </div>
    </TableHead>
  );
};
